@if (view$ | async; as view) {
    <div class="d-flex justify-content-end mb-3">
        <div ngbDropdown class="d-inline-block text-end" placement="bottom-right">
            <button type="button" class="btn btn-primary" id="viewForm" ngbDropdownToggle>
                {{ 'utilities_VIEW' | translate }}
            </button>
            <div ngbDropdownMenu aria-labelledby="viewForm">
                <form class="px-4 py-3" novalidate [formGroup]="view.visibleColumnsFormGroup">
                    <button
                        type="button"
                        class="btn btn-primary mb-3"
                        (click)="view.visibleColumnsFormGroup.reset()">
                        {{ 'utilities_standard-view' | translate }}
                    </button>
                    @for (col of view.headers; track col.key) {
                        @if (col.canHide) {
                            <app-checkbox-group
                                [formControlName]="col.key"
                                [label]="
                                    col.label.key
                                        | translate: col.label.application : col.label.module
                                " />
                        }
                    }
                </form>
            </div>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table table-striped text-nowrap">
            <thead>
                <tr>
                    @for (col of view.headers; track col.key) {
                        @if (view.visibleColumnsFormGroup.controls[col.key].value) {
                            <th>
                                <div class="d-flex align-items-center">
                                    @if (
                                        col.input?.formControlKey === 'idsInGroup1' ||
                                        col.input?.formControlKey === 'idsInGroup2'
                                    ) {
                                        <div class="form-check me-2">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                [checked]="view.meters[col.input?.valueKey!]"
                                                (change)="
                                                    metersSelected(
                                                        view.meters.all,
                                                        view.meterIdGroupsFormGroup.controls[
                                                            col.input?.formControlKey!
                                                        ],
                                                        $event
                                                    )
                                                " />
                                        </div>
                                    }

                                    <div
                                        app-sortable-table-header
                                        [column]="col.key"
                                        (sort)="
                                            onSort(
                                                {direction: $event.direction, column: col.key},
                                                view.meters.all
                                            )
                                        "
                                        [label]="
                                            col.label.key
                                                | translate
                                                    : col.label.application
                                                    : col.label.module
                                        "></div>
                                </div>
                            </th>
                        }
                    }
                </tr>

                <tr>
                    @for (col of view.headers; track col.key) {
                        @if (view.visibleColumnsFormGroup.controls[col.key].value) {
                            <th [formGroup]="view.filterFormGroup">
                                @switch (col.inputType) {
                                    @case ('text') {
                                        <app-input-text-group
                                            [labelCols]="0"
                                            [formControlName]="col.key" />
                                    }
                                    @case ('date') {
                                        <app-input-date-group [formControlName]="col.key" />
                                    }
                                    @case ('multiSelect') {
                                        <app-input-dropdown-checkboxes
                                            [formControlName]="col.key" />
                                    }
                                }
                            </th>
                        }
                    }
                </tr>
            </thead>

            <tbody>
                @for (meter of view.meters.paginated; track meter.meterIdAsNumber) {
                    <tr>
                        @for (col of view.headers; track col.key) {
                            @if (view.visibleColumnsFormGroup.controls[col.key].value) {
                                <td [class.text-danger]="meter.meterCriteriaMismatch">
                                    @if (col.key === 'meterNo') {
                                        {{ meter.meterNo }}
                                    } @else if (
                                        col.key === 'mountingDate' || col.key === 'dismountedDate'
                                    ) {
                                        {{ meter[col.key] | appdate }}
                                    } @else if (
                                        col.key === 'selectedGroup1' || col.key === 'selectedGroup2'
                                    ) {
                                        @if (meter.meterCriteriaMismatch === false) {
                                            <div class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input select-none"
                                                    [checked]="meter[col.key]"
                                                    [required]="view.compareGroups"
                                                    (change)="
                                                        metersSelected(
                                                            [meter],
                                                            view.meterIdGroupsFormGroup.controls[
                                                                col.input?.formControlKey!
                                                            ],
                                                            $event
                                                        )
                                                    " />
                                            </div>
                                        } @else if (col.key === 'selectedGroup1') {
                                            <div class="d-inline-flex">
                                                <app-tooltip
                                                    [popover]="meter.criteriaMismatchTranslation!"
                                                    customClass="bi bi-exclamation-circle-fill align-middle" />
                                            </div>
                                        }
                                    } @else {
                                        {{ meter[col.key] }}
                                    }
                                </td>
                            }
                        }
                    </tr>
                } @empty {
                    <tr>
                        <td colspan="13" class="text-start">
                            {{ 'common_No-data-available' | translate }}
                        </td>
                    </tr>
                }
            </tbody>

            <tr>
                <td colspan="1">
                    <app-control-messages
                        [control]="view.meterIdGroupsFormGroup.controls.idsInGroup1"
                        class="p-0" />
                </td>
                @if (view.compareGroups && view.meterIdGroupsFormGroup.controls.idsInGroup1.valid) {
                    <td colspan="1">
                        <app-control-messages
                            [control]="view.meterIdGroupsFormGroup.controls.idsInGroup2"
                            class="p-0" />
                    </td>
                }
            </tr>
        </table>
    </div>

    <app-pagination
        [collectionSize]="view.meters.filtered.length"
        [page]="view.page"
        (pageChange)="onPageChange($event)"
        [pageSize]="view.pageSize"
        (pageSizeChange)="onPageSizeChange($event)" />
}
